export default __webpack_public_path__ + "static/media/psi.4fb5935e.wav";